// extracted by mini-css-extract-plugin
export default {"btn":"ButtomRead_btn__2ko2-"};